import SubmitForm from "@/components/feature/SubmitForm";
import { brand } from "@/mocks/site";

export default function SubmitSection() {
  return (
    <section id="submit" className="scroll-mt-12 w-full py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-[11px] font-medium tracking-[0.24em] text-secondary-500">TIP LINE</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              投递线索与订阅简报
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              如果你手上有一份更完整的材料，或者你正身处某场风波之中，欢迎把它交给我们。
              我们会先做核实，再决定要不要进入归档流程，不核实的内容不会出现在站内。
            </p>

            <dl className="mt-7 flex flex-col gap-4 border-t border-background-300 pt-6">
              <div>
                <dt className="text-[11px] tracking-wide text-foreground-500">通用联系邮箱</dt>
                <dd className="mt-1 flex items-center gap-2 font-heading text-sm font-semibold text-foreground-900">
                  <i className="ri-mail-send-line text-base text-primary-700" aria-hidden="true" />
                  {brand.email}
                </dd>
              </div>
              <div>
                <dt className="text-[11px] tracking-wide text-foreground-500">线索专用邮箱</dt>
                <dd className="mt-1 flex items-center gap-2 font-heading text-sm font-semibold text-foreground-900">
                  <i className="ri-shield-keyhole-line text-base text-accent-600" aria-hidden="true" />
                  {brand.clueEmail}
                </dd>
              </div>
              <div>
                <dt className="text-[11px] tracking-wide text-foreground-500">简报频率</dt>
                <dd className="mt-1 text-sm leading-relaxed text-foreground-700">
                  每两周一次，只收录值得回头看的事件，不做每日推送。
                </dd>
              </div>
            </dl>
          </div>

          <div className="lg:col-span-8">
            <SubmitForm fieldPrefix="home" />
          </div>
        </div>
      </div>
    </section>
  );
}